export function normalizeText(value) {
  if (value == null) {
    return "";
  }

  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

export function hasValue(value) {
  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }

  if (typeof value === "number") {
    return Number.isFinite(value);
  }

  if (value == null) {
    return false;
  }

  const normalized = String(value).replace(/\s+/g, " ").trim();
  if (!normalized) {
    return false;
  }

  return !["-", "--", "---", "—", "N/A", "NULL"].includes(normalized.toUpperCase());
}

/**
 * Quantidade ZERO — "nenhum item desse tipo". As colunas de item da planilha
 * (terceiros BI–BN, acabamento CA–CD) são fórmula espelho da quantidade e
 * devolvem 0 quando a quantidade está vazia: contar esse zero como "item
 * esperado" inventava pendência em quase todo ambiente ativo.
 */
export function ehQuantidadeZero(value) {
  if (typeof value === "number") return value === 0;
  if (value == null) return false;
  const texto = String(value).trim().replace(",", ".");
  return /^0+(\.0+)?$/.test(texto);
}

export function isYes(value) {
  const normalized = normalizeText(value);
  return normalized === "SIM" || normalized === "S";
}

export function isNo(value) {
  const normalized = normalizeText(value);
  return normalized === "NAO" || normalized === "N";
}

export function toDisplayText(value, fallback = "—") {
  return hasValue(value) ? String(value).trim() : fallback;
}
